module.exports = "<div class=\"loading\">\n  <img src=\"assets/loading.svg\" alt=\"loading\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/callback/callback.component.html
// module id = ./src/app/callback/callback.component.html
// module chunks = main